import PropTypes from 'prop-types';
import React from 'react';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import {
  FacebookIcon,
  FacebookShareButton,
  FacebookShareCount,
  LineShareButton,
  LineIcon,
  PinterestIcon,
  PinterestShareCount,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton,
  TumblrIcon,
  TumblrShareButton,
  TumblrShareCount,
  WeiboShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  // LinkedinShareCount,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from 'react-share';
import config from '../../../content/meta/meta-config';
import weiboLogo from '../../images/share/weibo.png';
const PostShare = (props) => {
  const { previewImgSelfHost, previewImgExternal } = props;

  let title, slug, excerpt;
  if (props.post.contentful_id) {
    // contentful posts
    title = props.post.title;
    slug = props.post.slug;
    excerpt = props.post.excerpt.excerpt;
  } else {
    // markdown posts
    title = props.post.frontmatter.title;
    slug = props.post.fields.slug;
    excerpt = props.post.excerpt;
  }

  // console.log('🚀 ~ file: Share.js ~ line 40 ~ PostShare ~ previewImgExternal', previewImgExternal);

  const url = slug && slug !== '' ? config.siteUrl + config.pathPrefix + slug : config.siteUrl;
  // console.log('🚀 ~ file: Share.js ~ line 43 ~ PostShare ~ url', url);

  const iconSize = 36;
  // const filter = count => (count > 0 ? count : '');
  // console.log('previewImgSelfHost', previewImgSelfHost);
  // console.log('${config.siteUrl}${previewImgSelfHost}', `${config.siteUrl}${previewImgSelfHost}`);
  // console.log('${config.siteUrl}/preview.jpg', `${config.siteUrl}/preview.jpg`);
  return (
    <React.Fragment>
      <LabelStyled>好文分享</LabelStyled>
      <ShareStyled>
        <LinksStyled>
          <LineShareButton url={url} title={title}>
            <LineIcon size={iconSize} round />
          </LineShareButton>
          <WhatsappShareButton url={url} title={title}>
            <WhatsappIcon size={iconSize} round />
          </WhatsappShareButton>
          <TwitterShareButton url={url} title={title}>
            <TwitterIcon round size={iconSize} />
          </TwitterShareButton>
          <FacebookShareButton url={url} quote={`${title} - ${excerpt}`}>
            <FacebookIcon round size={iconSize} />
            {/* <FacebookShareCount url={url}>{count => <div className="share-count">{filter(count)}</div>}</FacebookShareCount> */}
          </FacebookShareButton>
          {/* <LinkedinShareButton
            url={url}
            title={title}
            description={excerpt}
          > */}
          {/* <LinkedinIcon round size={iconSize} /> */}
          {/* <LinkedinShareCount url={url}>{count => <div className="share-count">{filter(count)}</div>}</LinkedinShareCount> */}
          {/* </LinkedinShareButton> */}
          <PinterestShareButton
            url={url}
            media={
              previewImgSelfHost
                ? `${config.siteUrl}${previewImgSelfHost}`
                : previewImgExternal
                ? previewImgExternal
                : `${config.siteUrl}/preview.jpg`
            }
            description={excerpt}
            windowWidth={1000}
            windowHeight={730}
          >
            <PinterestIcon size={iconSize} round />
          </PinterestShareButton>
          {/* <PinterestShareCount url={url} className="share-count" /> */}
          {/* <TumblrShareButton url={url} title={title} windowWidth={660} windowHeight={460}>
            <TumblrIcon size={iconSize} round />
          </TumblrShareButton> */}
          {/* <TumblrShareCount url={shareUrl}
            className="Demo__some-network__share-count" /> */}
          <WeiboShareButton
            url={url}
            title={title}
            image={
              previewImgSelfHost
                ? `${config.siteUrl}${previewImgSelfHost}`
                : previewImgExternal
                ? previewImgExternal
                : `${config.siteUrl}/preview.jpg`
            }
          >
            <img className={weiboIcon} src={weiboLogo} alt="Weibo share button" />
          </WeiboShareButton>
          {/* <EmailShareButton url={url} subject={title} body="body">
            <EmailIcon size={iconSize} round />
          </EmailShareButton> */}
        </LinksStyled>
      </ShareStyled>
    </React.Fragment>
  );
};

PostShare.defaultProps = {
  previewImgSelfHost: null,
  previewImgExternal: null,
};

PostShare.propTypes = {
  post: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  previewImgSelfHost: PropTypes.string,
  previewImgExternal: PropTypes.string,
};

export default PostShare;

const LabelStyled = styled.div`
  color: var(--textTitle);
  font-size: 1.2em;
  margin: 1em 0 0.5em 0;
  text-align: center;
`;

const ShareStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const LinksStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;

  .SocialMediaShareButton {
    margin: 0 0.8em;
    cursor: pointer;
  }

  @media (max-width: 430px) {
    gap: 12px;
  }

  @media (max-width: 360px) {
    gap: 12px;
    .SocialMediaShareButton {
      margin: 0 0.4em;
    }
  }
`;

const weiboIcon = css`
  width: 36px;
  height: 36px;
`;
